export default __webpack_public_path__ + "static/media/a001-whatsapp-02.d6a73889.png";